import useMutationVariableCreateUpdate from './variable-use-mutation-create-update';
import useMutationVariableDelete from "./variable-use-mutation-delete";
import useMutationVariableUploadFile from "./variable-use-mutation-upload-file";
import useMutationVariableGroupDelete from "./variable-use-mutation-group-delete";
import useMutationVariableOrderSet from "./variable-use-mutation-order-set";

export const variableUseMutation = {
  createUpdate: useMutationVariableCreateUpdate,
  uploadFile: useMutationVariableUploadFile,
  delete: useMutationVariableDelete,
  deleteGroup: useMutationVariableGroupDelete,
  orderSet: useMutationVariableOrderSet
};